export const options = [
    { value: "newest", label: "Sort by newest review" },
    { value: "latest", label: "Sort by oldest review" },
];

export function getReviewsFilter(order, reviews) {
    if (order) return order === 'newest' ? [...reviews].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) : [...reviews].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
    return reviews;
}

export function formatDate(dateStr) {
    const date = new Date(dateStr);
    const month = date.toLocaleString('en-US', { month: 'short', timeZone: 'UTC' });
    const day = date.getUTCDate();
    const year = date.getUTCFullYear();
    const formattedDate = `${month} ${day}, ${year}`;
    return formattedDate;
}

const roundRating = (value) => Number(Number(value || 0).toFixed(1));

export function buildAutieReviewSummary(hotel, reviews = []) {
    if (!hotel || !Array.isArray(reviews) || reviews.length === 0) return hotel;

    const criteriaTotals = {};
    const reviewAverages = [];

    reviews.forEach((review) => {
        const rates = Array.isArray(review?.Rates) ? review.Rates : [];
        const numericRates = rates
            .map((rate) => Number(rate?.rates))
            .filter((rate) => Number.isFinite(rate));

        if (numericRates.length > 0) {
            reviewAverages.push(numericRates.reduce((sum, rate) => sum + rate, 0) / numericRates.length);
        }

        rates.forEach((rate) => {
            const criteriaName = rate?.RateCriterium?.name;
            const value = Number(rate?.rates);

            if (!criteriaName || !Number.isFinite(value)) return;

            if (!criteriaTotals[criteriaName]) {
                criteriaTotals[criteriaName] = { total: 0, count: 0 };
            }

            criteriaTotals[criteriaName].total += value;
            criteriaTotals[criteriaName].count += 1;
        });
    });

    const averageRates = Object.entries(criteriaTotals).reduce((acc, [criteriaName, value]) => {
        acc[criteriaName] = roundRating(value.total / value.count);
        return acc;
    }, {});

    const overallRating = reviewAverages.length > 0
        ? roundRating(reviewAverages.reduce((sum, value) => sum + value, 0) / reviewAverages.length)
        : hotel.overall_rating || 0;

    return {
        ...hotel,
        average_rates: Object.keys(averageRates).length > 0 ? averageRates : hotel.average_rates,
        overall_rating: overallRating,
    };
}
